import { EDGE_KINDS } from "utils/constants";

export const isSameRunSnapshot = (current, next) => {
  if (!current || !next) return false;
  return (
    current.id === next.id &&
    current.status === next.status &&
    current.updatedDate === next.updatedDate &&
    (current.currentNode && current.currentNode.id) ===
      (next.currentNode && next.currentNode.id)
  );
};

export const rememberRunNode = (cache, node) => {
  if (!cache || !node || !node.id) return cache;
  cache.set(node.id, node);
  return cache;
};

export const peekRunNode = (cache, nodeId) => {
  if (!cache || !nodeId) return null;
  return cache.get(nodeId) || null;
};

export const optimisticCurrentNode = (run, nodeId, cache) => {
  const node = peekRunNode(cache, nodeId);
  if (!run || !node) return null;
  return { ...run, currentNode: node };
};

/**
 * An action that keeps the user on the screen can still move the funnel when
 * the process wires an EVENT edge to its trigger - typically towards a twin
 * step that re-displays the same screen under another status.
 */
export const hasEventEdge = (run, event) => {
  if (!event) return false;
  const edges =
    (run && run.currentNode && run.currentNode.possibleStatuses) || [];
  return edges.some(
    (edge) => edge && edge.kind === EDGE_KINDS.EVENT && edge.event === event,
  );
};

export const backTargetNodeId = (run) => {
  const stack = (run && run.context && run.context.navigationStack) || [];
  if (stack.length) return stack[stack.length - 1];
  const edges =
    (run && run.currentNode && run.currentNode.possibleStatuses) || [];
  const back = edges.find((edge) => edge && edge.event === "back");
  return (back && back.nextStatus) || null;
};
